import { Box, Button, FormControl, InputAdornment, TextField } from "@mui/material";
import { InputLabel } from "components/common/Input";
import { Formik } from "formik";
import useSWR from "swr";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, fetcher } from "services/api.service";

type EarningsDebitProps = {
  description?: string;
};

type TransactionGroup = {
  quickbooksId: string;
  earningsDebit: string;
  postedAt: Date;
  description: string;
};

export function EarningsDebitTransactionGroupForm({ description }: EarningsDebitProps) {
  const { uuid, transactionGroupId } = useParams();
  const [today] = useState(() => new Date());
  const navigate = useNavigate();

  const { data: transactionGroup } = useSWR<TransactionGroup>(
    transactionGroupId ? `/organizations/${uuid}/transaction_groups/${transactionGroupId}` : null,
    fetcher,
  );

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={
          transactionGroup || {
            quickbooksId: "",
            earningsDebit: "",
            postedAt: today,
            description: "Earnings debit",
          }
        }
        onSubmit={(values) => {
          api
            .post(`/organizations/${uuid}/transaction_groups`, {
              transactionGroup: { type: "EarningsDebit", ...values, ...(description ? { description } : {}) },
            })
            .then(({ data }) => {
              navigate(`/finance/clients/${uuid}/transaction_groups/EarningsDebit/${data.id}`, {
                replace: true,
              });
            });
        }}
      >
        {({ getFieldProps, handleSubmit }) => (
          <Box
            sx={{
              p: 4,
              mb: 4,
              background: "background.paper",
              borderRadius: 1,
              border: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4 }}>
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink>Debit Amount:</InputLabel>
                <TextField
                  size="small"
                  {...getFieldProps("earningsDebit")}
                  disabled={!!transactionGroupId}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink>Posted At:</InputLabel>
                <TextField
                  id="name"
                  size="small"
                  type={transactionGroupId ? "" : "date"}
                  {...getFieldProps("postedAt")}
                  disabled={!!transactionGroupId}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink>Quickbooks ID:</InputLabel>
                <TextField size="small" {...getFieldProps("quickbooksId")} disabled={!!transactionGroupId} />
              </FormControl>
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink>Description:</InputLabel>
                <TextField size="small" {...getFieldProps("description")} disabled={!!transactionGroupId} />
              </FormControl>
            </Box>
            {!transactionGroupId && (
              <Box display="flex" justifyContent="flex-end" mt={6}>
                <Button variant="contained" onClick={() => handleSubmit()}>
                  Save
                </Button>
              </Box>
            )}
          </Box>
        )}
      </Formik>
    </>
  );
}
